export default () => [
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/auth/Login.vue')
  },
  {
    path: '/reset_password/:jwt',
    name: 'reset_password',
    component: () => import('@/views/auth/ResetPassword.vue')
  }
]
